/**
 * @param {Observable<string>} concurrencyUrl$
 * @param {globx.Store<Config>}
 * @returns {Subscription}
 */

const subscribeToConcurrencyUpdate = (
    concurrencyUrl$,
    configStore
) =>
    concurrencyUrl$
        .subscribe(concurrencyServiceUrl => configStore.actions.configure({
            serviceUrls: {
                concurrency: concurrencyServiceUrl,
            },
        }));

export default subscribeToConcurrencyUpdate;

